import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=933cb90a&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=ts&"
export * from "./pc.vue?vue&type=script&lang=ts&"
import style0 from "./pc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./pc.vue?vue&type=style&index=1&id=933cb90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933cb90a",
  null
  
)

export default component.exports